import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { firestoreConnect, isEmpty, isLoaded } from "react-redux-firebase"
import { compose } from "redux"
import Presentation from "./Presentation"
import {
  deleteArticle,
  restoreArticle,
  followOrUnfollow,
  voteForArticle,
  revertArticle,
} from "../../middleware"
import CircularSpinner from "../../../../shared/circularSpinner"

function Container(props) {
  const {
    selectedArticle,
    selectedHistory,
    isHistory,
    categoryMetaInfo,
  } = props

  const [state, setState] = useState({
    data: {},
  })

  useEffect(() => {
    let data = {}
    if (isHistory) {
      if (isLoaded(selectedHistory)) {
        data = selectedHistory[0].eventDetails.after
      }
    } else {
      if (isLoaded(selectedArticle)) {
        data = selectedArticle[0]
      }
    }
    setState((state) => ({ ...state, data }))
  }, [selectedArticle, selectedHistory, isHistory, categoryMetaInfo])

  if (
    isLoaded(state.data) &&
    !isEmpty(state.data) &&
    isLoaded(categoryMetaInfo)
  ) {
    return (
      <Presentation
        {...state}
        categoryMetaInfo={categoryMetaInfo[0]}
        isHistory={isHistory}
        articleId={props.articleId}
        onDeleteArticle={props.onDeleteArticle}
        onRestoreArticle={props.onRestoreArticle}
        onRevertArticle={props.onRevertArticle}
        onFollowOrUnfollow={props.onFollowOrUnfollow}
        auth={props.auth}
        OnVote={props.OnVote}
        access_modules={props.access_modules}
      />
    )
  }
  return (
    <CircularSpinner />
  )
}

const mapStateToProps = (state, ownProps) => {
  // console.error(state.firestore.errors.byQuery.selectedArticle)
  const firestore = state.firestore.ordered
  return {
    selectedArticle: firestore.selectedArticle,
    selectedHistory: firestore.selectedHistory,
    categoryMetaInfo: firestore.categoryMetaInfo,
    auth: state.firebase.auth,
    access_modules: state.employee.employeeModules.accessModules,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDeleteArticle: (articleId, history) => {
      dispatch(deleteArticle(articleId, history))
    },
    onRestoreArticle: (articleId, categoryId, history) => {
      dispatch(restoreArticle(articleId, categoryId, history))
    },
    onRevertArticle: (payload, articleId, categoryId, history) => {
      dispatch(revertArticle(payload, articleId, categoryId, history))
    },
    onFollowOrUnfollow: (articleId, type) => {
      dispatch(followOrUnfollow(articleId, type))
    },
    OnVote: (articleId, type) => {
      dispatch(voteForArticle(articleId, type))
    },
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    const { articleId, isHistory, historyId } = props
    const collections = [
      {
        collection: "WIKI",
        where: [["id", "==", articleId]],
        storeAs: "selectedArticle",
      },
      {
        collectionGroup: "ARTICLE_HISTORY",
        where: [["id", "==", historyId]],
        storeAs: "selectedHistory",
      },
      {
        collection: "ID_TRACKER",
        doc: "categories",
        storeAs: "categoryMetaInfo",
      },
    ]
    if (isHistory) return [collections[1], collections[2]]
    return [collections[0], collections[2]]
  })
)(Container)
